import { render } from "./PriceMarkupSetting.vue?vue&type=template&id=a649a32a"
import script from "./PriceMarkupSetting.vue?vue&type=script&lang=js"
export * from "./PriceMarkupSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__